/* eslint-disable react/jsx-props-no-spreading */
import { type FC, lazy, Suspense } from "react";
import { type ProductPhotoCassetteProps } from "@legacy_user_frontend/components/pages/mypage/profiles/profiles_show/src/profile_show_props";
import type { Settings } from "react-slick";
import { retryLazyLoad } from "@root/shared/utils/retryLazyLoad";
import * as styles from "../styles.css";

const Slider = lazy(() => retryLazyLoad({ fn: () => import("react-slick") }));

export const ProductPhotoCassette: FC<ProductPhotoCassetteProps> = ({ productPhotos }) => {
  const settings: Settings = {
    responsive: [
      {
        // breakpointはmax-widthの指定のみのためPC指定に9999を使用する
        breakpoint: 9999,
        settings: "unslick",
      },
      {
        breakpoint: 768,
        settings: {
          infinite: false,
          arrows: false,
          autoplay: false,
          slidesToShow: 1,
          variableWidth: true,
          swipeToSlide: true,
        },
      },
    ],
  };

  return (
    <div className={styles.sliderOuter}>
      <Suspense fallback={<div>Loading...</div>}>
        <Slider {...settings}>
          {productPhotos.map(({ description, imageUrl }) => {
            const trimmedDescription =
              !!description && description.length > 15
                ? `${description.substring(0, 15)}...`
                : description;
            return (
              <div key={imageUrl}>
                <div className={styles.sliderImageOuter}>
                  <img src={imageUrl} alt={trimmedDescription} />
                </div>
                <p className={styles.sliderDescription}>{trimmedDescription}</p>
              </div>
            );
          })}
        </Slider>
      </Suspense>
    </div>
  );
};
